import { defineMessage } from 'services/localization';

export const messages = {
    paymentMethod: defineMessage('payment_method'),
    entityType: defineMessage('entity_type'),
    company: defineMessage('company'),
    individual: defineMessage('individual'),
    selectPlaceholder: defineMessage('select'),
    confirmChanges: defineMessage('confirm_changes_1'),
    confirmChangesDescription: defineMessage('are_you_sure_you_want_t_details_will_be_cleared'),
    confirm: defineMessage('confirm'),
};
